"use strict";

exports.__esModule = true;
exports.industries = exports.categories = void 0;
var categories = [{
  title: '手机海报',
  url: '/templates',
  list: [{
    title: '手机海报',
    url: '/templates',
    type: 'hot'
  }, {
    title: '长图海报',
    url: '/templates'
  }]
}, {
  title: '社交媒体',
  url: '/templates',
  list: [{
    title: '公众号首图',
    url: '/templates'
  }, {
    title: '公众号次图',
    url: '/templates'
  }, {
    title: '关注二维码',
    url: '/templates'
  }, {
    title: 'GIF动图',
    url: '/templates',
    type: 'new'
  }, {
    title: '日签',
    url: '/templates'
  }, {
    title: '朋友圈邀请函',
    url: '/templates'
  }, {
    title: '社交名片',
    url: '/templates'
  }, {
    title: '更多',
    url: '/templates',
    type: 'more'
  }]
}, {
  title: '印刷物料',
  url: '/templates',
  list: [{
    title: '印刷海报',
    url: '/templates'
  }, {
    title: '宣传单',
    url: '/templates'
  }, {
    title: '名片',
    url: '/templates'
  }, {
    title: '易拉宝',
    url: '/templates'
  }, {
    title: '菜单',
    url: '/templates'
  }, {
    title: '优惠券',
    url: '/templates'
  }, {
    title: '更多',
    url: '/templates',
    type: 'more'
  }]
}, {
  title: '电商平台',
  url: '/templates',
  list: [{
    title: '手机端店铺首页',
    url: '/templates'
  }, {
    title: '手机端详情海报',
    url: '/templates'
  }, {
    title: 'PC端详情海报',
    url: '/templates'
  }, {
    title: 'PC端首页海报',
    url: '/templates'
  }, {
    title: '主图图标',
    url: '/templates'
  }, {
    title: '详情页',
    url: '/templates'
  }, {
    title: '手机端首页海报',
    url: '/templates'
  }]
}, {
  title: '门店营销',
  url: '/templates',
  list: [{
    title: '外卖平台店招',
    url: '/templates'
  }, {
    title: '外卖平台海报',
    url: '/templates'
  }, {
    title: '外卖平台商品主图',
    url: '/templates'
  }]
}, {
  title: '办公文档',
  url: '/templates',
  list: [{
    title: 'PPT',
    url: '/templates'
  }, {
    title: '简历',
    url: '/templates'
  }]
}, {
  title: '生活娱乐',
  url: '/templates',
  list: [{
    title: '相册',
    url: '/templates'
  }, {
    title: '电子贺卡',
    url: '/templates'
  }]
}];
exports.categories = categories;
var industries = [{
  title: 'IT互联网',
  url: '/templates'
}, {
  title: '教育培训',
  url: '/templates'
}, {
  title: '餐饮美食',
  url: '/templates'
}, {
  title: '广告传媒',
  url: '/templates'
}, {
  title: '旅游出行',
  url: '/templates'
}, {
  title: '金融理财',
  url: '/templates'
}, {
  title: '文化娱乐',
  url: '/templates'
}, {
  title: '运动健身',
  url: '/templates'
}, {
  title: '美容美妆',
  url: '/templates'
}, {
  title: '地产家居',
  url: '/templates'
}, {
  title: '办公百货',
  url: '/templates'
}, {
  title: '医疗保健',
  url: '/templates'
}, {
  title: '服饰零售',
  url: '/templates'
}, {
  title: '司法党政',
  url: '/templates'
}, {
  title: '母婴亲子',
  url: '/templates'
}, {
  title: '数码家电',
  url: '/templates'
}, {
  title: '生活服务',
  url: '/templates'
}, {
  title: '公益环保',
  url: '/templates'
}];
exports.industries = industries;